



































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Picker, Popup, DatetimePicker } from 'vant';
Vue.use(Picker).use(Popup).use(DatetimePicker);
@Component
export default class PickerInput extends Vue {
  @Prop() title!: string;
  @Prop({ default: false }) ifshowPicker!: boolean;
  @Prop({ default: false }) ifshowDatePicker!: boolean;
  @Prop({ default: false }) ifshowClassPicker!: boolean;
  @Prop({ default: false }) ifshowSexPicker!: boolean;
  @Prop() PickerTypeData!: object;
  @Prop() PickeWorkTypeData!: object;
  @Prop() PickeAreasData!: object;
  @Prop({ default: '请选择' }) placeholder!: string;
  typeValue: string = '';
  workTypevalue: string = '';
  Datevalue: string = '';
  Classvalue: string = '';
  areasValue: string = '';
  Sexvalue: string = '';
  PickeClassData: any[] = [];
  PickeSexData = ['男', '女'];
  minDate = new Date(1960, 0, 1);
  maxDate = new Date(2020, 10, 1);
  currentDate = new Date();

  showPicker: boolean = false;
  @Watch('workTypevalue')
  onPickerDataChanged(newVal: any, val: any) {
    if (newVal && val) {
      console.log('workType重新选择', newVal, val);
      setTimeout(() => {
        this.$router.go(0);
      }, 100);
    }
  }
  created() {
    for (let i = 1; i < 51; i++) {
      this.PickeClassData.push(`${i}班`);
    }
    // console.log('this.PickeClassData', this.PickeClassData);
  }
  startPicker() {
    this.showPicker = true;
  }
  onConfirmType(e: string, index: number) {
    this.$emit('selectTypeData', e, index);
    this.typeValue = e;
    this.showPicker = false;
  }
  onConfirmWorkType(e: string, index: number) {
    this.$emit('selectWorkTypeData', e, index);
    this.workTypevalue = e;
    this.showPicker = false;
  }
  onConfirmAreas(e: string, index: number) {
    this.$emit('selectAreasData', e, index);
    this.areasValue = e;
    this.showPicker = false;
  }
  onConfirmDate(e: string, index: number) {
    const date = new Date(e);
    this.Datevalue =
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.$emit('selectDateData', this.Datevalue, index);
    this.showPicker = false;
  }
  onConfirmClass(e: string, index: number) {
    this.$emit('selectClassData', e, index);
    this.Classvalue = e;
    this.showPicker = false;
  }
  onConfirmSex(e: string, index: number) {
    this.$emit('selectSexData', e, index);
    this.Sexvalue = e;
    this.showPicker = false;
  }
}
